import { PointLightProps } from "@react-three/fiber";
import React, { createRef, useContext, useEffect, useRef } from "react";
import MusicNode from "./MusicNode";
import { Howl } from "howler";
import { AppContext } from "./App";
import { TimerOptions } from "timers";

export default function MusicNodeManager() {
  // MUSIC LENGTH: 42.245s
  const musicLength = 42920;
  const { soundHasLoaded, hasStarted } = useContext(AppContext);
  const lightHeight = 0;
  const howlSettings = {
    loop: true,
    preload: true,
    onload: () => soundHasLoaded(),
    volume: 0,
    autoplay: false,
  };
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const musicNodes = useRef([
    {
      lightRef: createRef(),
      position: [25, lightHeight, 25],
      color: "#FF4466",
      detail: 1,
      sound: new Howl({
        src: ["/audio/moonrecording/minS.ogg", "/audio/moonrecording/minS.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [30, lightHeight, 0],
      color: "#FF4466",
      detail: 2,
      sound: new Howl({
        src: ["/audio/moonrecording/minM.ogg", "/audio/moonrecording/minM.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [25, lightHeight, -25],
      color: "#FF4466",
      detail: 3,

      sound: new Howl({
        src: ["/audio/moonrecording/minL.ogg", "/audio/moonrecording/minL.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [-25, lightHeight, 25],
      color: "#FF4466",
      detail: 1,
      sound: new Howl({
        src: ["/audio/moonrecording/majS.ogg", "/audio/moonrecording/majS.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [-30, lightHeight, 0],
      color: "#FF4466",
      detail: 2,

      sound: new Howl({
        src: ["/audio/moonrecording/majM.ogg", "/audio/moonrecording/majM.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [-25, lightHeight, -25],
      color: "#FF4466",
      detail: 3,
      sound: new Howl({
        src: ["/audio/moonrecording/majL.ogg", "/audio/moonrecording/majL.mp3"],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [0, lightHeight, 30],
      color: "#2211ff",
      detail: 1,
      sound: new Howl({
        src: [
          "/audio/moonrecording/MelodieS.ogg",
          "/audio/moonrecording/MelodieS.mp3",
        ],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [0, lightHeight, 10],
      color: "#2211ff",
      detail: 2,
      sound: new Howl({
        src: [
          "/audio/moonrecording/MelodieM.ogg",
          "/audio/moonrecording/MelodieM.mp3",
        ],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [0, lightHeight, -10],
      color: "#2211ff",
      detail: 2,
      sound: new Howl({
        src: [
          "/audio/moonrecording/MelodieL.ogg",
          "/audio/moonrecording/MelodieL.mp3",
        ],
        ...howlSettings,
      }),
    },
    {
      lightRef: createRef(),
      position: [0, lightHeight, -30],
      color: "#2211ff",
      detail: 3,
      sound: new Howl({
        src: [
          "/audio/moonrecording/MelodieXL.ogg",
          "/audio/moonrecording/MelodieXL.mp3",
        ],
        ...howlSettings,
      }),
    },
  ]);

  function playSounds() {
    musicNodes.current.forEach((node) => {
      node.sound.stop();
      node.sound.play();
    });
    // timerRef.current = setTimeout(playSounds, musicLength);
  }

  useEffect(() => {
    if (hasStarted) {
      playSounds();
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [hasStarted]);

  return (
    <>
      {musicNodes.current.map((node, index) => {
        return <MusicNode {...node} key={index} />;
      })}
    </>
  );
}
